import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { map, mergeMap } from "rxjs/operators";
import { ProjectService } from "../../services/project.service";
import {ProjectSessionTypes } from './project-session-actions'

@Injectable()
export class ProjectSessionEffects {
    projectname!:string;

    loadProjectSessionData = createEffect(() => 
    this.actions$.pipe(ofType(ProjectSessionTypes.InvokeApisTypes), 
    mergeMap((action:any) => {
        return this.projectService.getProjectSessionData(action.projectname)
        .pipe(map((data) => ({type:ProjectSessionTypes.GetProjectSessionType, projectsessionreq:data})))
    })));

   constructor(private actions$:Actions, private projectService:ProjectService){}
}